<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Ürünü Reddet</h3>
          <button @click="closeModal" class="close-btn">
            <img src="../../assets/images/cross.svg" alt="Close" />
          </button>
        </div>

        <div class="modal-body">
          <p class="rejection-question">Ürünü neden reddetmek istiyorsunuz?</p>

          <div class="input-group">
            <label for="rejectionReason" class="input-label">Açıklama ekleyin</label>
            <textarea
              id="rejectionReason"
              v-model="rejectionReason"
              class="rejection-input"
              placeholder="Reddetme sebebinizi buraya yazın..."
              rows="4"
            ></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">
            İptal
          </button>
          <button
            @click="confirmReject"
            class="btn-reject"
            :disabled="!rejectionReason.trim() || isSubmitting"
          >
            <span v-if="isSubmitting">Reddediliyor...</span>
            <span v-else>Ürünü Reddet</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'RejectItemModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      rejectionReason: '',
      isSubmitting: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.rejectionReason = '';
        this.isSubmitting = false;
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    confirmReject() {
      if (!this.rejectionReason.trim()) return;

      this.isSubmitting = true;
      this.$emit('confirm', {
        item: this.item,
        rejectionReason: this.rejectionReason.trim()
      });
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e1e5e9;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-btn:hover {
  background: #f3f4f6;
}

.close-btn img {
  width: 16px;
  height: 16px;
}

.modal-body {
  padding: 24px;
}

.rejection-question {
  font-size: 16px;
  color: #374151;
  margin: 0 0 20px 0;
}

.input-group {
  margin-bottom: 20px;
}

.input-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.rejection-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
  transition: border-color 0.2s;
}

.rejection-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.rejection-input::placeholder {
  color: #9ca3af;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e1e5e9;
}

.btn-cancel,
.btn-reject {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
}

.btn-cancel {
  background: white;
  border-color: #d1d5db;
  color: #374151;
}

.btn-cancel:hover {
  background: #f9fafb;
}

.btn-reject {
  background: #dc2626;
  border-color: #dc2626;
  color: white;
}

.btn-reject:hover:not(:disabled) {
  background: #b91c1c;
  border-color: #b91c1c;
}

.btn-reject:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

</style>
